import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { formatShortDateFromNow } from '../../../../../utils/date-utils/dateUtils';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { NotificationMessageType } from '../../../notification.types';
import {
  sendNotificationClickedEvent,
  getNotificationTrackingParameters,
} from '../../../notificationUtils';
import { notificationSelected } from '../../../state/actions';
import styles from './notification_message.module.scss';
import { NotificationLink } from '../../link/NotificationLink';
import { NotificationLinkDate } from '../../link/NotificationLinkDate';
import { NotificationLinkContent } from '../../link/NotificationLinkContent';

type Props = {
  notification: NotificationMessageType;
  notificationClicked: Function;
};

export const NotificationMessage: FC<Props> = ({
  notification,
  notificationClicked,
}) => {
  const dispatch = useDispatch();
  const onRead = async (notificationId: number) => {
    await dispatch(notificationSelected(notificationId));
  };

  const onNotificationClicked = async (
    event: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    sendNotificationClickedEvent();

    if (!notification.internalLink) {
      try {
        await onRead(notification.id);
      } catch (error) {
        throw error;
      }
    }
    notificationClicked(notification)(event);
  };

  return (
    <NotificationLink
      href={
        notification.internalLink
          ? buildUrlWithParameters(
              notification.link,
              getNotificationTrackingParameters(notification),
            )
          : notification.link
      }
      onClick={onNotificationClicked}
      target={notification.internalLink ? '' : '_blank'}
      data-test-id="notification-message"
    >
      <span className={styles.border} />
      <NotificationLinkContent>
        <span
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: notification.data.message }}
        />
        <NotificationLinkDate>
          {formatShortDateFromNow(notification.date)}
        </NotificationLinkDate>
      </NotificationLinkContent>
    </NotificationLink>
  );
};
